import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useMemo, useCallback, useEffect, useRef } from 'react';
import styled, { keyframes } from 'styled-components';
import clss from 'classnames';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var optShow = keyframes([
    "0%{transform:scaleY(0);}70%{transform:scaleY(1.2);}100%{transform:scaleY(1);}"
]);
var optHide = keyframes([
    "0%{transform:scaleY(1);}40%{transform:scaleY(1.2);}90%{transform:scaleY(0);}100%{transform:scaleY(0);display:none;}"
]);
var SelectLayout = styled.div.withConfig({
    displayName: "Select__SelectLayout",
    componentId: "sc-d185j1-0"
})([
    "",
    " .select-box{",
    " &:focus,&:active{",
    "}.search-input{",
    " input{",
    "}}.multi-item{",
    "}&.multi{",
    "::-webkit-scrollbar{width:1px;height:1px;}}&.single .value{",
    "}}.search-input{",
    " input{",
    "}}.placeholder{",
    "}.select-opt{transform-origin:top;display:none;z-index:2;",
    " .opt-item{",
    " &.active{",
    "}}&.show{display:block;}&.hide{display:none;}}"
], {
    "position": "relative",
    "minWidth": "150px"
}, {
    "borderColor": "var(--color-border)",
    "minHeight": "36px",
    "paddingLeft": "10px",
    "paddingRight": "10px",
    "display": "flex",
    "alignItems": "center",
    "color": "var(--color-text)",
    "width": "100%"
}, {
    "borderColor": "var(--color-text-primary)"
}, {
    "borderStyle": "none",
    "minWidth": "50px",
    "paddingLeft": "0",
    "paddingRight": "0"
}, {
    "width": "100%",
    "display": "inline-block"
}, {
    "backgroundColor": "var(--color-select-bg)",
    "color": "var(--color-text-primary)",
    "borderRadius": "8px",
    "marginRight": "10px",
    "display": "inline-flex",
    "paddingLeft": "5px",
    "paddingRight": "5px",
    "paddingTop": "2px",
    "paddingBottom": "2px",
    "alignItems": "center"
}, {
    "overflowX": "scroll"
}, {
    "textAlign": "right",
    "color": "var(--color-text-primary)",
    "fontSize": "15px",
    "paddingRight": "6px",
    "width": "calc(100% - 17px)",
    "overflowX": "hidden",
    "whiteSpace": "nowrap",
    "textOverflow": "ellipsis"
}, {
    "borderColor": "var(--color-text-primary)",
    "backgroundColor": "var(--color-box-bg)",
    "borderWidth": "1px",
    "borderRadius": "8px",
    "minHeight": "36px",
    "paddingLeft": "10px",
    "paddingRight": "10px",
    "display": "flex",
    "alignItems": "center",
    "color": "var(--color-text)",
    "justifyContent": "center"
}, {
    "backgroundColor": "rgba(0, 0, 0, 0)",
    "outline": "2px solid transparent",
    "outlineOffset": "2px"
}, {
    "color": "var(--color-text-secondary)",
    "textAlign": "center",
    "position": "absolute",
    "fontSize": "15px",
    "left": "10px",
    "width": "calc(100% - 30px)"
}, {
    "position": "absolute",
    "--tw-shadow": "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)",
    "top": "calc(100% + 5px)",
    "paddingLeft": "8px",
    "paddingRight": "8px",
    "paddingTop": "8px",
    "paddingBottom": "8px",
    "left": "0px",
    "color": "var(--color-desc-text)",
    "width": "100%",
    "borderWidth": "1px",
    "borderColor": "var(--color-border)",
    "borderRadius": "8px",
    "backgroundColor": "var(--color-box-bg)",
    "overflow": "hidden"
}, {
    "width": "100%",
    "textAlign": "center",
    "paddingLeft": "10px",
    "paddingRight": "10px",
    "paddingTop": "12px",
    "paddingBottom": "12px",
    "cursor": "pointer",
    ":hover": {
        "backgroundColor": "var(--color-select-bg)",
        "color": "var(--color-text-primary)"
    },
    "overflowWrap": "break-word",
    "fontSize": "14px"
}, {
    "backgroundColor": "var(--color-select-bg)",
    "color": "var(--color-text-primary)",
    "fontWeight": "400",
    "borderStyle": "none",
    "borderRadius": "4px"
});
var Select = function(props) {
    var ref6 = props || {}, selected = ref6.selected, _mode = ref6.mode, mode = _mode === void 0 ? 'single' : _mode, search = ref6.search, options = ref6.options, onChange = ref6.onChange, className = ref6.className, placeholder = ref6.placeholder, _showClear = ref6.showClear, showClear = _showClear === void 0 ? false : _showClear;
    var ref1 = useState([]), current = ref1[0], setCurrent = ref1[1];
    var ref2 = useState([]), filterOpt = ref2[0], setFilterOpt = ref2[1];
    var ref3 = useState(''), optState = ref3[0], setOptState = ref3[1];
    var ref4 = useState(false), singleInputShow = ref4[0], setSingleInputShow = ref4[1];
    var ref5 = useState(''), searchText = ref5[0], setSearchText = ref5[1];
    var multiSearch = useRef(null);
    var selectRef = useRef(null);
    var isMulti = useMemo(function() {
        return mode === 'multi';
    }, [
        mode
    ]);
    var isMultiSearch = useMemo(function() {
        return mode === 'multi' && search;
    }, [
        mode,
        search
    ]);
    var showEmpty = useMemo(function() {
        return !options.length || searchText && !options.some(function(o) {
            return o.label.toString().match(searchText);
        });
    }, [
        options,
        searchText
    ]);
    var onSelect = useCallback(function(opt) {
        var newCurrent = [];
        if (isMulti) {
            if (!current.some(function(c) {
                return c.value === opt.value;
            })) {
                newCurrent = _toConsumableArray(current).concat([
                    opt
                ]);
                onChange && onChange(newCurrent.map(function(c) {
                    return c.value;
                }));
            } else {
                newCurrent = current;
            }
        } else {
            newCurrent = [
                opt
            ];
            onChange && onChange(newCurrent[0] && newCurrent[0].value || '');
            setSingleInputShow(false);
        }
        setCurrent(newCurrent);
    }, [
        options,
        isMulti,
        current,
        onChange
    ]);
    useEffect(function() {
        if (selected !== undefined) {
            if (isMulti) {
                if (_instanceof(selected, Array)) {
                    selected.forEach(function(s) {
                        var t = options.find(function(o) {
                            return o.value === s;
                        });
                        if (t) {
                            setCurrent(_toConsumableArray(current).concat([
                                t
                            ]));
                        }
                    });
                } else {
                    throw 'in multi mode, selected must be a array';
                }
            } else {
                console.log(options, selected);
                var t1 = options.find(function(o) {
                    return o.value === selected;
                });
                if (t1) {
                    setCurrent([
                        t1
                    ]);
                }
            }
        }
    }, [
        isMulti,
        options,
        selected
    ]);
    var isActive = useCallback(function(value) {
        return current.some(function(c) {
            return c.value === value;
        }) ? 'active' : '';
    }, [
        options,
        current
    ]);
    var onSelectBlur = useCallback(function() {
        if (!isMultiSearch) {
            setSingleInputShow(false);
            setTimeout(function() {
                setOptState('hide');
            }, 300);
        }
    }, [
        singleInputShow,
        isMultiSearch
    ]);
    var onSelectFocus = useCallback(function() {
        if (isMultiSearch && multiSearch) {
            var ref;
            (ref = multiSearch.current) === null || ref === void 0 ? void 0 : ref.focus();
        } else if (!isMulti && search) {
            setSingleInputShow(true);
        }
        setOptState('show');
    }, [
        search,
        isMulti,
        isMultiSearch,
        multiSearch
    ]);
    var onClear = useCallback(function() {
        setCurrent([]);
        onChange && onChange('');
    }, [
        isMulti,
        onChange
    ]);
    var onClearItem = useCallback(function(value) {
        var newCurrent = current.filter(function(c) {
            return c.value !== value;
        });
        setCurrent(newCurrent);
        onChange && onChange(newCurrent.map(function(c) {
            return c.value;
        }));
    }, [
        current,
        onChange
    ]);
    var onClickSelect = useCallback(function() {
        if (isMultiSearch && multiSearch) {
            var ref;
            (ref = multiSearch.current) === null || ref === void 0 ? void 0 : ref.focus();
        } else if (!isMulti && search) {
            setSingleInputShow(true);
        }
        setOptState('show');
        if (mode === 'single' && optState === 'show') {
            var ref7;
            setOptState('hide');
            (ref7 = selectRef.current) === null || ref7 === void 0 ? void 0 : ref7.blur();
        }
    }, [
        isMultiSearch,
        multiSearch,
        optState,
        selectRef,
        mode
    ]);
    var onBlurSearch = function(e) {
        var ref;
        var newOptState = optState;
        if (showEmpty) {
            newOptState = '';
            setOptState(newOptState);
        }
        if (!(e === null || e === void 0 ? void 0 : (ref = e.relatedTarget) === null || ref === void 0 ? void 0 : ref.contains(multiSearch.current)) || !isMultiSearch) {
            setTimeout(function() {
                newOptState && setOptState('hide');
                setSingleInputShow(false);
                setSearchText('');
                setFilterOpt([]);
            }, 250);
        }
    };
    var onFocusSesarch = useCallback(function() {
        setSearchText(current[0] && current[0].label.toString() || '');
    }, [
        current,
        mode,
        optState
    ]);
    var onChangeSearch = useCallback(function(e) {
        var newSeasrchText = e.target.value;
        setSearchText(newSeasrchText);
        var newFilterOpt = options.filter(function(i) {
            return i.label.toString().match(newSeasrchText);
        });
        setFilterOpt(newFilterOpt);
    }, [
        options
    ]);
    return(/*#__PURE__*/ _jsxs(SelectLayout, {
        className: className,
        children: [
            singleInputShow ? /*#__PURE__*/ _jsx("div", {
                className: "search-input",
                children: /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    value: searchText,
                    autoFocus: true,
                    onFocus: onFocusSesarch,
                    onBlur: onBlurSearch,
                    onChange: onChangeSearch
                })
            }) : /*#__PURE__*/ _jsxs("div", {
                className: "select-box ".concat(mode),
                tabIndex: -1,
                onBlur: onSelectBlur,
                onClick: onClickSelect,
                ref: selectRef,
                children: [
                    current.map(function(c) {
                        /*#__PURE__*/ return _jsxs("span", {
                            className: isMulti ? 'multi-item' : 'value',
                            children: [
                                c.label,
                                isMulti && /*#__PURE__*/ _jsx(ClearIcon, {
                                    onClick: function() {
                                        return onClearItem(c.value);
                                    },
                                    className: "fill-gray-500 cursor-pointer"
                                })
                            ]
                        }, c.value);
                    }),
                    !current.length && !singleInputShow && !searchText && placeholder && /*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ _jsx("span", {
                            className: "placeholder font-[500]",
                            children: placeholder
                        })
                    }),
                    isMulti && search && /*#__PURE__*/ _jsx("div", {
                        className: "search-input",
                        children: /*#__PURE__*/ _jsx("input", {
                            tabIndex: 0,
                            ref: multiSearch,
                            value: searchText,
                            autoFocus: true,
                            onFocus: function() {
                                return setOptState('show');
                            },
                            onBlur: onBlurSearch,
                            onChange: onChangeSearch
                        })
                    })
                ]
            }),
            current.length && !isMulti && showClear ? /*#__PURE__*/ _jsx(ClearIcon, {
                onClick: onClear,
                className: "fill-gray-300 absolute right-[10px] cursor-pointer top-[10px]"
            }) : /*#__PURE__*/ _jsx(SelectIcon, {
                className: clss({
                    '!rotate-[225deg] !top-[16px] !border-primary': optState === 'show',
                    '!border-primary': current.length
                }, 'absolute right-[10px] top-[14px]')
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "select-opt ".concat(optState),
                children: showEmpty ? /*#__PURE__*/ _jsx("span", {
                    className: "text-desc px-[10px] py-[10px] block text-center",
                    children: "no data"
                }) : (filterOpt.length ? filterOpt : options).map(function(o) {
                    /*#__PURE__*/ return _jsx("li", {
                        className: "opt-item ".concat(isActive(o.value)),
                        onClick: function() {
                            return onSelect(o);
                        },
                        children: o.label
                    }, o.value);
                })
            })
        ]
    }));
};
var ClearIcon = function(param) {
    var className = param.className, onClick = param.onClick;
    return(/*#__PURE__*/ _jsx("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        className: className,
        onClick: function(e) {
            e.stopPropagation();
            onClick && onClick();
        },
        children: /*#__PURE__*/ _jsx("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        })
    }));
};
var SelectIcon = function(param) {
    var className = param.className;
    return(/*#__PURE__*/ _jsx("div", {
        className: clss('absolute right-[15px] w-[6px] h-[6px] transition-transform border-b-[1px] border-r-[1px] rotate-[45deg] border-secondary', className)
    }));
};
export default Select;
